import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 overflow-hidden bg-cream" data-id="element-82">
      {/* Subtle background decoration */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-earth-light/30 rounded-full blur-3xl -z-10 opacity-50" data-id="element-83" />

      <div className="max-w-6xl mx-auto px-6 lg:px-8" data-id="element-84">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-85">
          <div className="max-w-2xl" data-id="element-86">
            <FadeIn data-id="element-87">
              <span className="inline-block py-1 px-3 rounded-full bg-accent/10 text-accent font-medium text-sm mb-6 tracking-wide uppercase" data-id="element-88">
                Solución Inmediata
              </span>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-89">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.15] text-earth-darker mb-6" data-id="element-90">
                DEJA DE SUFRIR POR LOS CÓLICOS DE TU BEBÉ EN{' '}
                <span className="text-accent italic" data-id="element-91">15 MINUTOS O MENOS</span>
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-92">
              <p className="text-lg md:text-xl text-earth-dark mb-8 leading-relaxed" data-id="element-93">
                El método físico "Neuro-Soothe" diseñado para padres agotados
                que necesitan que su bebé deje de llorar... AHORA.
              </p>
            </FadeIn>
          </div>

          <FadeIn delay={0.4} direction="left" className="relative lg:ml-auto" data-id="element-94">
            <div className="relative w-full max-w-md mx-auto lg:max-w-none" data-id="element-95">
              {/* Decorative blob behind image */}
              <div className="absolute inset-0 bg-earth-light rounded-[2rem] transform rotate-3 scale-105 -z-10" data-id="element-96" />
              <img src="https://cdn.magicpatterns.com/uploads/jKHP3BLb6tSsVFAE8qqCF6/Lucid_Origin_rofessional_digital_product_mockup_of_a_modern_iP_0.jpg" alt="Serenidad Nocturna - Manual Digital en iPad" className="relative z-10 w-full h-auto rounded-2xl shadow-2xl" data-id="element-97" />
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}